import script from "./ProfitAndLossView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitAndLossView.vue?vue&type=script&setup=true&lang=js"

import "./ProfitAndLossView.vue?vue&type=style&index=0&id=091b0f97&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091b0f97"]])

export default __exports__